import { useEffect } from "react";
import { useDispatch } from "react-redux";
import ICONS from "../../../assets/Icons";
import { beneBankLookUp } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { ownerListViewAllAcc } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { beneLookUp } from "../../../redux/features/verifyPAN/verifyPAN";
import { formatAccountNumber } from "../../_utils/FormatAccountNumber";
import DataActionField from "../../_utils/TransactionCommonComponents/DataActionField";
import SVGComponent from "../../_utils/SVGComponent";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const RefactorInternalTxnSelectAccount = ({
  internalTxnData,
  refactAccDetail,
  setRefactorAccDetail,
  refactorDestinationAccDetail,
  setRefactorDestinationAccDetail,
  refactorConfidentailDetail,
  setRefactorConfidentailDetail,
  refactorTxnData,
  txnPayLoad,
  setTxnPayLoad,
  setIsConfidential,
  isConfidential,
  beneTransCategories,
  setBeneAccountId,
  setAccountName,
  setAccountNumber,
  setPanNumber,
  setIFSC,
  setBankLogo,
  setCategory,
  setSelectedCategory,
  internalAccData,
  setAutoFill,
}) => {
  const config =
    internalTxnData?.transaction?.[0]?.confidential_transaction !== "N";
  useEffect(() => {
    if (
      refactorTxnData?.confidential_transaction === "N" &&
      isConfidential === false
    ) {
      setRefactorConfidentailDetail(true);
    } else if (
      refactorTxnData?.confidential_transaction === "Y" &&
      isConfidential === true
    ) {
      setRefactorConfidentailDetail(true);
    }
  }, [isConfidential]);

  const dispatch = useDispatch();

  return (
    <div className="flex flex-col Qsmd:justify-center Qsmd:flex-row gap-gap-md lg:gap-gap-xl Qsmd:my-margin-md h-screen bg-primary-bg Qsmd:bg-primary-card Qsmd:h-auto w-width-full fixed z-z-index-content Qsmd:relative top-top-base left-left-base mt-margin-base">
      <div className="h-mobile-create-header flex w-width-full bg-primary-nav Qmd:hidden">
        <div className="p-padding-md">
          <div
            className="flex flex-shrink-0 cursor-pointer"
            onClick={() => {
              setAutoFill(false);
            }}
          >
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color="var(--text-primary)"
              height={"var(--icon-sm)"}
              width={"var(--icon-sm)"}
              alt="Arrow right"
            />
          </div>
        </div>
        <div className="flex flex-col w-width-full py-padding-sm">
          <div className="text-text-primary text-font-md">
            Create transaction
          </div>
          <p className=" text-text-primary text-font-xs font-semibold">
            Previous transaction details
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-gap-md Qsmd:flex-1 w-width-full h-auto px-padding-md Qsmd:px-padding-base">
        <DataActionField
          label="Source Account"
          value={formatAccountNumber(
            refactorTxnData?.owner_account_bank_acc_no,
          )}
          icon={
            refactAccDetail
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          hoverEnabled={!refactAccDetail}
          onClick={() => {
            if (refactAccDetail) return;
            setRefactorAccDetail(true);
            setTxnPayLoad({
              ...txnPayLoad,
              ownerId: refactorTxnData?.owner_account_id,
              ownerBankIFSC: refactorTxnData?.owner_account_ifsc_code,
              ownerBankBalance: refactorTxnData?.owner_account_balance,
              ownerBankLogo: refactorTxnData?.owner_account_bank_name,
              ownerLastUpdated:
                refactorTxnData?.owner_account_balance_last_fetched_at_in_words,
              ownerBankAccountNo: refactorTxnData?.owner_account_bank_acc_no,
              settleType: "NEFT",
              ownerBankAccountName: refactorTxnData?.owner_account_bank_name,
            });
          }}
        />

        <DataActionField
          label="Create As Confidential Transaction"
          value={
            internalTxnData?.transaction?.[0]?.confidential_transaction === "Y"
              ? "Confidential transaction enabled"
              : "Confidential transaction disabled"
          }
          isActive={isConfidential === config}
          icon={
            isConfidential === config
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          hoverEnabled={isConfidential !== config}
          onClick={() => {
            if (
              internalTxnData?.transaction?.[
                GlobalConfiguration?.lengthCheckZero
              ]?.confidential_transaction === "Y"
            ) {
              setIsConfidential(true);
            } else if (
              internalTxnData?.transaction?.[
                GlobalConfiguration?.lengthCheckZero
              ]?.confidential_transaction === "N"
            ) {
              setIsConfidential(false);
            }
          }}
        />
      </div>

      <div
        className={`flex flex-col gap-gap-md Qsmd:flex-1 w-width-full h-auto px-padding-md Qsmd:px-padding-base ${txnPayLoad?.ownerId !== null ? "" : "cursor-not-allowed"}`}
      >
        {/* {txnPayLoad?.ownerId !== null && ( */}
        <DataActionField
          label="Destination Account"
          value={refactorTxnData?.internal_account_name
            ?.toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")}
          icon={
            refactorDestinationAccDetail
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          hoverEnabled={!refactorDestinationAccDetail}
          onClick={async () => {
            if (refactorDestinationAccDetail) return;

            const isDisabled =
              internalAccData?.[0]?.approval_status === "rejected" ||
              internalAccData?.[0]?.approval_status === "blocked";

            if (isDisabled) return;

            const acc = internalAccData?.[0];

            const categoriesArray = acc?.category?.split(",");
            setCategory(categoriesArray);
            setAccountName(acc?.name);
            setAccountNumber(acc?.bank_acc_no);
            setIFSC(acc?.ifsc_code);
            setBankLogo(acc?.bank_name);
            setBeneAccountId(acc?.id);
            setPanNumber(acc?.pan_no);
            setSelectedCategory(null);

            dispatch(beneLookUp({ pan_number: acc?.pan_no }));
            dispatch(
              beneBankLookUp({
                ifsc: acc?.ifsc_code,
                bank_account_no: acc?.bank_acc_no,
              }),
            );

            const data1 = await dispatch(
              ownerListViewAllAcc({
                bank_account_no: acc?.bank_acc_no,
                pan: acc?.pan_no,
                ifsc: acc?.ifsc_code,
              }),
            );

            setTxnPayLoad({
              ...txnPayLoad,
              bankAccountName: refactorTxnData?.internal_account_name,
              beneAccountId: refactorTxnData?.internal_account_id,
              bankAccountIFSC: refactorTxnData?.internal_account_ifsc_code,
              bankAccountNo: refactorTxnData?.internal_account_bank_acc_no,
              bankLogo: refactorTxnData?.internal_account_bank_name,
              pan: acc?.pan_no,
              isDestinationOwnerActive: acc?.internal_account,
              destinationAccountBalance:
                data1?.payload?.owner_accounts?.[0]?.owner_account_balance,
              destinationAcountOwnerId: data1?.payload?.owner_accounts?.[0]?.id,
              destinationAcountOwnerLastUpdated:
                data1?.payload?.owner_accounts?.[0]
                  ?.owner_account_balance_last_fetched_at_in_words,
              selectedCategory: beneTransCategories?.categories?.find(
                (c) => c.name === "Internal",
              ),
              mergeCategory: beneTransCategories?.categories?.find(
                (c) => c.name === "Internal",
              )?.configuration?.data,
            });

            setRefactorDestinationAccDetail(true);
          }}
          disabled={txnPayLoad?.ownerId === null}
        />
        {/* )} */}
      </div>
    </div>
  );
};

export default RefactorInternalTxnSelectAccount;
